import { axiosInstance } from "features/api";
import { projectsUrl } from "../api";

import ApiService from "features/service";

class ProjectService extends ApiService {
  /** Handle requests to the project api endpoint. */

  listUrl = projectsUrl;

  connectAccount(projectId, country) {
    // Connects a user's account to stripe.
    const url = `${this._getDetailUrl(projectId)}connect/`;
    return axiosInstance.post(url, { country });
  }

  getStripeDashboard(projectId) {
    // Returns the data for accessing the project's stripe dashboard.
    const url = `${this._getDetailUrl(projectId)}stripe_dashboard/`;
    return axiosInstance.get(url);
  }

  getPurchasedClasses(projectId) {
    // Return the classes that the url has purchased.
    const url = `${this.listUrl}purchased/`;
    return axiosInstance.get(url);
  }

  createTeacher(projectId, payload) {
    // Creates a teacher and adds their split percent.
    const url = `${this._getDetailUrl(projectId)}add_teacher/`;
    return axiosInstance.post(url, payload);
  }

  sendContactEmail(projectId, payload) {
    // Sends a contact email to the teacher(s) of the project.
    const url = `${this._getDetailUrl(projectId)}contact/`;
    return axiosInstance.post(url, payload);
  }

  listEnrollments(projectId) {
    // Returns a list of the project's enrollments.
    return axiosInstance.get(`${this._getDetailUrl(projectId)}enrollments/`);
  }

  listAccounts(projectId) {
    // Return data about the stripe accounts associated with the project.
    const url = `${this._getDetailUrl(projectId)}stripe_accounts/`;
    return axiosInstance.get(url);
  }

  share(projectId) {
    // Shares the project to the global feed.
    const url = `${this._getDetailUrl(projectId)}share/`;
    return axiosInstance.post(url);
  }

  comments(projectId) {
    // Fetches the comments for a given project.
    const url = `${this._getDetailUrl(projectId)}comments/`;
    return axiosInstance.get(url);
  }

  joinMailingList(projectId, payload) {
    // Add your email to the project's mailing list.
    const url = `${this._getDetailUrl(projectId)}mailing_list/`;
    return axiosInstance.post(url, payload);
  }
}

export default ProjectService;
